/**
 * Socket.io event name constants.
 *
 * Source of truth: klab-messaging-ws-ms/src/resources/asyncapi/api-messaging-ws-ms.yaml
 *
 * Convention: events are grouped by direction.
 *   - ClientToServerEvents: emitted by the Angular client to the WS server
 *     (chat:message:send, chat:message:edit, chat:typing:start, ...)
 *   - ServerToClientEvents: broadcast by the WS server to the client
 *     (chat:message:new, chat:presence:update, chat:error, ...)
 */

export const CHAT_EVENTS = {
  // ── Client → Server ──────────────────────────────────────────
  INIT: "chat:init",

  CONVERSATION_CREATE: "chat:conversation:create",
  CONVERSATION_PIN: "chat:conversation:pin",

  MESSAGE_SEND: "chat:message:send",
  MESSAGE_FORWARD: "chat:message:forward",
  MESSAGES_FETCH: "chat:messages:fetch",
  MESSAGE_SEEN_BY_FETCH: "chat:message:seen-by:fetch",
  FILES_FETCH: "chat:files:fetch",
  MESSAGES_AROUND: "chat:messages:around",
  MESSAGES_DATE_JUMP: "chat:messages:date-jump",
  MESSAGES_SEARCH: "chat:messages:search",
  MESSAGE_DELIVERED: "chat:message:delivered",
  MESSAGE_READ: "chat:message:read",
  MESSAGE_EDIT: "chat:message:edit",
  MESSAGE_DELETE: "chat:message:delete",
  MESSAGE_PIN: "chat:message:pin",
  MESSAGE_REACTION_TOGGLE: "chat:message:reaction:toggle",

  TYPING_START: "chat:typing:start",
  TYPING_STOP: "chat:typing:stop",

  GROUP_UPDATE: "chat:group:update",
  GROUP_MEMBER_ADD: "chat:group:member:add",
  GROUP_MEMBER_REMOVE: "chat:group:member:remove",
  GROUP_MEMBER_ROLE_UPDATE: "chat:group:member:role:update",
  GROUP_DELETE: "chat:group:delete",

  /**
   * @deprecated Upload through DocumentS3UploadService, then send the final
   * media reference with MESSAGE_SEND.
   */
  MEDIA_UPLOAD_REQUEST: "chat:media:upload:request",

  PRESENCE_QUERY: "chat:presence:query",
  PRESENCE_HEARTBEAT: "chat:presence:heartbeat",

  // ── Server → Client ──────────────────────────────────────────
  CONVERSATION_CREATED: "chat:conversation:created",
  CONVERSATION_NEW: "chat:conversation:new",
  CONVERSATION_PINNED: "chat:conversation:pinned",

  MESSAGE_NEW: "chat:message:new",
  MESSAGE_FORWARD_BLOCKED: "chat:message:forward:blocked",
  MESSAGE_DELIVERED_UPDATE: "chat:message:delivered:update",
  MESSAGE_READ_UPDATE: "chat:message:read:update",
  MESSAGE_READ_RESULT: "chat:message:read:result",
  MESSAGE_EDITED: "chat:message:edited",
  MESSAGE_DELETED: "chat:message:deleted",
  MESSAGE_PINNED: "chat:message:pinned",
  MESSAGE_REACTIONS_CHANGED: "chat:message:reactions:changed",

  TYPING_INDICATOR: "chat:typing:indicator",

  GROUP_UPDATED: "chat:group:updated",
  GROUP_MEMBER_ADDED: "chat:group:member:added",
  GROUP_MEMBER_REMOVED: "chat:group:member:removed",
  GROUP_MEMBER_ROLE_UPDATED: "chat:group:member:role:updated",
  GROUP_MEMBER_ROLE_UPDATE_RESULT: "chat:group:member:role:update:result",
  GROUP_DELETED: "chat:group:deleted",
  PARTICIPANT_IDENTITY_UPDATED: "chat:participant:identity:updated",

  PRESENCE_UPDATE: "chat:presence:update",

  ERROR: "chat:error",
  MEDIA_REJECTED: "chat:media:rejected",
} as const;

export type ChatEventName = (typeof CHAT_EVENTS)[keyof typeof CHAT_EVENTS];
